var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7452 30.3516L23.3908 22.6597C25.5417 20.2957 26.8647 17.1679 26.8647 13.7272C26.866 6.39379 20.8999 0.427734 13.5665 0.427734C6.23301 0.427734 0.266968 6.39379 0.266968 13.7272C0.266968 21.0607 6.23301 27.0267 13.5665 27.0267C16.5747 27.0267 19.3428 26.0117 21.5725 24.3215L28.9651 32.0529C29.2066 32.3066 29.5305 32.4335 29.8558 32.4335C30.1625 32.4335 30.468 32.3202 30.707 32.0923C31.1973 31.6229 31.2158 30.8419 30.7452 30.3516ZM2.73075 13.7272C2.73075 7.75256 7.59179 2.89152 13.5665 2.89152C19.5411 2.89152 24.4022 7.75256 24.4022 13.7272C24.4022 19.7019 19.5411 24.563 13.5665 24.563C7.59179 24.563 2.73075 19.7019 2.73075 13.7272Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZoom);
export default __webpack_public_path__ + "static/media/icon-zoom.77ed83e24b96422dd2d825fcde6ed111.svg";
export { ForwardRef as ReactComponent };